import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import InfoIcon from '@mui/icons-material/Info';
import useApp from "../../store/contexts/AppContext";

function UserExtendingRoomTime({ roomName, roomId, handleUserExtendingRoomTimeClose }) {
  const {
    extendRoomExpirationTimeApiCall
  } = useApp();

  const [openTooltip, setOpenTooltip] = React.useState(false);

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };

  const handleExtensionOfRoomTime = () => {
    extendRoomExpirationTimeApiCall(roomId);
    handleUserExtendingRoomTimeClose();
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        gap: "10px",
        p: 2,
        backgroundColor: "white",
        border: "1px solid #ccc",
      }}
    >
      <div>Are you sure you want to fund room: <b>{roomName}</b>, with your coin?</div>
      <div>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={handleTooltipClose}
              open={openTooltip}
              // disableFocusListener
              disableHoverListener
              // disableTouchListener
              title="2 coins is valued for 30 minutes, and you'll be charged 2 coins to process this transaction"
            >
            </Tooltip>
            <div sx={{
              float: "right",
              textAlign: "right",
            }}>
              <Chip onClick={handleTooltipOpen} icon={<InfoIcon />} label="Read More" variant="outlined" />
            </div>
          </div>
        </ClickAwayListener>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="success"
          onClick={handleExtensionOfRoomTime}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleUserExtendingRoomTimeClose}
        >
          Cancel
        </Button>
      </div>
    </Box>
  );
}

export default UserExtendingRoomTime;
